module.exports = __webpack_public_path__ + "img/tishi.b4ab9035.svg";